import React from "react";
import { funnData } from "../../../data";

function Funn() {
  const {
    brand,
    slogan,
    description,
    legacy,
    innovation,
    performance,
    riders,
    style,
  } = funnData;

  return (
    <div className="w-full mx-auto space-y-5">
      {/* Brand Intro */}
      <div className="bg-gray-50 p-6 rounded-xl shadow-sm">
        <h1 className="text-3xl font-bold text-gray-900">{brand}</h1>
        {slogan && (
          <p className="text-sm italic text-gray-500 my-2">“{slogan}”</p>
        )}
        <p className="text-gray-700 leading-relaxed text-base">{description}</p>
      </div>

      {/* Legacy */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">Legacy</h2>
        <p className="text-gray-700 text-sm leading-relaxed">
          {legacy.history}
        </p>
      </div>

      {/* Innovation */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">
          Cutting-Edge Innovation
        </h2>
        <p className="text-gray-700 text-sm leading-relaxed">
          {innovation.commitment}
        </p>
      </div>

      {/* Performance */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">
          Trail-Tested Performance
        </h2>
        <p className="text-gray-700 text-sm leading-relaxed">
          {performance.testing}
        </p>
      </div>

      {/* Riders */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">
          Meet our 2023 team of extraordinary riders
        </h2>
        <p className="text-gray-700 text-sm leading-relaxed mb-1">
          {riders.description}
        </p>
        <ul className="list-disc pl-6 text-gray-700 text-sm space-y-1">
          {riders["2023Team"].map((rider, index) => (
            <li key={index}>{rider}</li>
          ))}
        </ul>
      </div>

      {/* Style */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">
          Style Meets Function
        </h2>
        <p className="text-gray-700 text-sm leading-relaxed">
          {style.description}
        </p>
      </div>
    </div>
  );
}

export default Funn;
